import { gql } from '@apollo/client'

import { IMAGES } from './IMAGES';
import { PRODUCT } from './PRODUCT.gql';
import { HIGHLIGHT_CARD } from './HIGHLIGHT_CARD.gql'

export const BLOCKS = gql`
  ${PRODUCT}
  ${HIGHLIGHT_CARD}
  fragment blocks on EntryInterface {
    id
    ... on banner_Entry {
      typeHandle
      image {
        ${IMAGES('bannerImage')}
      }
      mainTitle
      linkTitle
      ctaUrl {
        type
        url
      }
    }
    ... on text_Entry {
      typeHandle
      mainTitle
      text
      linkTitle
      ctaUrl {
        type
        url
      }
    }
    ... on twoColumnImage_Entry {
      typeHandle
      mainTitle
      text
      image {
        ${IMAGES('twoColumnImage')}
      }
      position
      linkTitle
      ctaUrl {
        type
        url
      }
    }
    ... on usps_Entry {
      typeHandle
      mainTitle
      usps {
        ... on usp_Entry {
          id
          icon
          title
          text
        }
      }
      linkTitle
      ctaUrl {
        type
        url
      }
    }
    ... on quoteLoop_Entry {
      typeHandle
      quote
    }
    ... on pricingCards_Entry {
      typeHandle
      mainTitle
      products {
        ...product
      }
    }
    ... on mindbodyWidget_Entry {
      typeHandle
      mainTitle
      dataType
      widgetPartner
      widgetId
      widgetVersion
    }
      ... on MindBodyBrandedWebWidget_Entry {
      typeHandle
      mainTitle
      dataType
      widgetId
    }
    ... on calendlyWidget_Entry {
      typeHandle
      mainTitle
      calendlyId
    }
    ... on bsportCalendarWidget_Entry {
      typeHandle
      mainTitle
      widgetConfig
    }
    ... on bsportPassesWidget_Entry {
      typeHandle
      mainTitle
      widgetConfig
    }
    ... on bsportAppointmentsWidget_Entry {
      typeHandle
      mainTitle
      widgetConfig
    }
    ... on twoColumn2_Entry {
      typeHandle
      mainTitle
      linkTitle
      text
      ctaUrl {
        type
        uri
        url
      }
    }
    ... on smallBanner_Entry {
      id
      typeHandle
      mainTitle
      linkTitle
      ctaUrl {
        type
        uri
        url
      }
      text
      image {
        ${IMAGES('smallBanner')}
      }
    }
    ... on cardsSlider_Entry {
      id
      typeHandle
      cards {
        ...highlightCard
      }
    }
    ... on twoCards_Entry {
      typeHandle
      mainTitle
      cards {
        ... on cards2Block_Entry {
          id
          mainTitle
          subtitle
          linkTitle
          image {
            ${IMAGES('cardImage')}
          }
          ctaUrl {
            type
            url
          }
        }
      }
    }
    ... on imageSlider_Entry {
      typeHandle
      images {
         ${IMAGES('imageSlider')}
      }
    }
    ... on video_Entry {
      typeHandle
      mainTitle
      subTitle
      placeholderImage {
        ${IMAGES('videoPlaceholderImage')}
      }
      embed {
        data {
          youtube_id
        }
      }
    }
    ... on accordion_Entry {
      id
      typeHandle
      mainTitle
      items {
        title
        text
      }
    }
  }
`;
